import {query_all, get_ie_version, /*get_scroll_top, get_element_top*/} from 'lib/utilities';
// import TweenValue from 'lib/tween-value';

import initializeParallax from 'lib/parallax';
import ScrollAnimations from "../../lib/scroll-animations";

const IE_VERSION = get_ie_version();

function translate(element, x = 0, y = 0, z = 0) {
    element.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)';
}

export default function init_scroll_animations(app) {
    if (IE_VERSION && IE_VERSION <= 11) {
        app.scrollAnimations = ScrollAnimations();

        // init_parallax_fallback(app);
    } else {
        app.scrollAnimations = ScrollAnimations({
            scrollElement: document.getElementById('viewport')
        });

        document.documentElement.classList.add('css-parallax');

        const viewport = document.getElementById('viewport');

        initializeParallax(viewport);
        init_scrollbar_compensation(viewport);
    }

    setTimeout(app.scrollAnimations.resize, 2000);

    init_home_animations(app);
}

function init_home_animations(app) {
    const elements = query_all('.template-home section.section-content .content-body');

    elements.forEach((element, index) => {
        app.scrollAnimations.add_animation({
            element,
            update(model, ratio) {
                let direction = index % 2 === 0 ? 1 : - 1;
                let scaled = ratio * 2 - 1;
                let x = scaled * 50 * direction;

                translate(model.element, x);
            },
            reset(model) {
                model.element.style.transform = '';
            },
            resize(model) {
                model.isEnabled = app.breakpoints.gte('desktop');
            },
            enabled(model) {
                return model.isEnabled && ! app.detectTouchDevice.is_touch_device();
            }
        })
    });
}

function init_scrollbar_compensation(viewport) {
    const languageSelector = document.getElementById('language-selector');

    function resize() {
        languageSelector.style.marginRight = viewport.offsetWidth - viewport.clientWidth + 'px';
    }

    resize();

    window.addEventListener('resize', resize);
}

// function init_parallax_fallback(app) {
//     const parallaxElements = Array.from(document.querySelectorAll('[data-parallax]'));
//
//     function parallax(element, factor = null, marginMultiplier = 0.5) {
//         let top = get_element_top(element);
//
//         factor = factor ?? parseFloat(element.getAttribute('data-parallax'));
//
//         if (IE_VERSION) {
//             factor /= 2;
//         }
//
//         let activeBreakpoints = element.getAttribute('data-parallax-enabled');
//
//         if (activeBreakpoints) {
//             activeBreakpoints = activeBreakpoints
//                 .split(',')
//                 .map(name => name.trim());
//         }
//
//         if (isNaN(factor)) {
//             console.error('Invalid data-parallax-factor', factor, element.getAttribute('data-parallax-factor'), element);
//
//             return;
//         }
//
//         app.scrollAnimations.add_animation({
//             element,
//             smooth: !! IE_VERSION,
//             tween: IE_VERSION ? TweenValue(get_scroll_top(), 15) : null,
//             update(model, ratio, scrollTop) {
//                 const y = Math.round(factor * (scrollTop - top));
//                 // IE has some odd glitches when doing - adding a non-zero value for the Z dimension fixes it
//                 const z = IE_VERSION ? 0.001 : 0;
//
//                 translate(model.element, 0, y, z);
//             },
//             reset(model) {
//                 model.element.style.transform = '';
//             },
//             resize(model) {
//                 model.margin = window.innerHeight * marginMultiplier;
//
//                 model.element.style.webkitBackfaceVisibility = 'hidden';
//                 model.element.style.backfaceVisibility = 'hidden';
//
//                 top = get_element_top(element);
//             },
//             enabled() {
//                 if (activeBreakpoints) {
//                     return activeBreakpoints.indexOf(app.breakpoints.get_current().name) !== -1;
//                 }
//
//                 return true;
//             }
//         });
//     }
//
//     for (const element of parallaxElements) {
//         parallax(element);
//     }
// }